import { render, staticRenderFns } from "./SkuChoose.vue?vue&type=template&id=8b8143b2&scoped=true&"
import script from "./SkuChoose.vue?vue&type=script&lang=js&"
export * from "./SkuChoose.vue?vue&type=script&lang=js&"
import style1 from "./SkuChoose.vue?vue&type=style&index=1&lang=less&"
import style2 from "./SkuChoose.vue?vue&type=style&index=2&id=8b8143b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8143b2",
  null
  
)

export default component.exports